"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.ProvisioningStateStatus = exports.ProvisioningStateAction = void 0;
var ProvisioningStateAction;
(function (ProvisioningStateAction) {
    ProvisioningStateAction["CREATE_ACCOUNT"] = "CREATE_ACCOUNT";
    ProvisioningStateAction["MIGRATE_ACCOUNT"] = "MIGRATE_ACCOUNT";
    ProvisioningStateAction["CANCEL_ACCOUNT"] = "CANCEL_ACCOUNT";
    ProvisioningStateAction["ACTIVATE_ACCOUNT"] = "ACTIVATE_ACCOUNT";
    ProvisioningStateAction["ENROLL_AUTHORIZED_USER"] = "ENROLL_AUTHORIZED_USER";
    ProvisioningStateAction["CANCEL_AUTHORIZED_USER"] = "CANCEL_AUTHORIZED_USER";
    ProvisioningStateAction["REPLACE_AUTHORIZED_USER"] = "REPLACE_AUTHORIZED_USER";
    ProvisioningStateAction["CHANGE_OWNER"] = "CHANGE_OWNER";
    ProvisioningStateAction["UPDATE_METADATA"] = "UPDATE_METADATA";
    ProvisioningStateAction["UPDATE_MEMBER_INFO"] = "UPDATE_MEMBER_INFO";
    ProvisioningStateAction["PRODUCT_CHANGE"] = "PRODUCT_CHANGE";
})(ProvisioningStateAction = exports.ProvisioningStateAction || (exports.ProvisioningStateAction = {}));
var ProvisioningStateStatus;
(function (ProvisioningStateStatus) {
    ProvisioningStateStatus["ACCOUNT_CANCELED"] = "ACCOUNT_CANCELED";
    ProvisioningStateStatus["ACCOUNT_ACTIVE"] = "ACCOUNT_ACTIVE";
    ProvisioningStateStatus["ACCOUNT_MIGRATED"] = "ACCOUNT_MIGRATED";
})(ProvisioningStateStatus = exports.ProvisioningStateStatus || (exports.ProvisioningStateStatus = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://businessplus.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Business Plus States API
 * @version v1
 * @baseUrl https://businessplus.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags BusinessPlusStatesJournal
             * @name BusinessPlusStatesJournalGetJournalChanges
             * @request GET:/v1/businessPlusStates/journal
             * @secure
             */
            businessPlusStatesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/businessPlusStates/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusStatesJournal
             * @name BusinessPlusStatesJournalGetJournalMaxClock
             * @request GET:/v1/businessPlusStates/journal/maxClock
             * @secure
             */
            businessPlusStatesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/businessPlusStates/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateGetBusinessPlusStates
             * @request GET:/v1/users/{userId}/businessPlusStates
             * @secure
             */
            businessPlusStateGetBusinessPlusStates: (userId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateCreateBusinessPlusState
             * @request POST:/v1/users/{userId}/businessPlusStates
             * @secure
             */
            businessPlusStateCreateBusinessPlusState: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateGetEntitlement
             * @request GET:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}
             * @secure
             */
            businessPlusStateGetEntitlement: (userId, businessPlusStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateChangeWebsiteDomain
             * @request POST:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}/changeWebsiteDomain
             * @secure
             */
            businessPlusStateChangeWebsiteDomain: (userId, businessPlusStateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}/changeWebsiteDomain`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateChangeUserEmail
             * @request POST:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}/changeUserEmail
             * @secure
             */
            businessPlusStateChangeUserEmail: (userId, businessPlusStateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}/changeUserEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateEntitlementUpdate
             * @request POST:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}/entitlementUpdate
             * @secure
             */
            businessPlusStateEntitlementUpdate: (userId, businessPlusStateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}/entitlementUpdate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateMakeLoginLink
             * @request POST:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}/makeLoginLink
             * @secure
             */
            businessPlusStateMakeLoginLink: (userId, businessPlusStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}/makeLoginLink`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateDeleteResource
             * @request DELETE:/v1/users/{userId}/businessPlusState/{businessPlusStateId}
             * @secure
             */
            businessPlusStateDeleteResource: (businessPlusStateId, userId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusState/${businessPlusStateId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Migration
             * @name MigrationMigrate
             * @request PUT:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}/migrate
             * @secure
             */
            migrationMigrate: (userId, businessPlusStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}/migrate`, method: 'PUT', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=businessplus.js.map